/**
 * Pre-wedding empty state — shown on the dashboard when the user has zero
 * weddings. Renders welcome copy + a CTA that opens CreateWeddingModal.
 */
import React from 'react';
import { Button } from '../ui/button';
import { Plus } from 'iconoir-react';

export default function EmptyWeddingState({ userName, onCreate }) {
  return (
    <div
      className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4"
      data-testid="no-wedding-state"
    >
      <img
        src="https://images.unsplash.com/photo-1646925910552-513704cf0f22?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjB3ZWRkaW5nJTIwZGVjb3IlMjBmbG9yYWwlMjBuZXV0cmFsfGVufDB8fHx8MTc3NjM2MjkxMHww&ixlib=rb-4.1.0&q=85"
        alt="Wedding decor"
        className="w-48 h-48 object-cover rounded-full mb-8 border-4 border-white shadow-lg"
      />
      <h1 className="font-serif font-light text-4xl sm:text-5xl text-charcoal tracking-tight mb-4">
        Welcome, {userName}
      </h1>
      <p className="text-muted font-light text-lg max-w-md mb-8">
        Start planning your dream wedding by creating your first wedding budget.
      </p>
      <Button
        onClick={onCreate}
        className="btn-primary flex items-center gap-2"
        data-testid="create-first-wedding-btn"
      >
        <Plus className="w-4 h-4" />
        Create Your Wedding
      </Button>
    </div>
  );
}
